import { desktopBlur, type CardDirection, type FlowThemeCardMotion } from '../../cardMotion';

/**
 * Sinking past the cards: the next one drifts up from below while the last one
 * rises away overhead, with a slight sway as if carried by the water.
 */
export const oceanCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const travel = isMobile ? 96 : 130;
  return {
    variants: {
      enter: (direction: CardDirection) => ({
        opacity: 0,
        y: direction > 0 ? travel : -travel,
        rotate: direction > 0 ? -1.5 : 1.5,
        scale: 0.97,
        filter: desktopBlur(isMobile, 6),
      }),
      center: { opacity: 1, y: 0, rotate: 0, scale: 1, filter: isMobile ? undefined : 'blur(0px)' },
      exit: (direction: CardDirection) => ({
        opacity: 0,
        y: direction > 0 ? -travel : travel,
        rotate: direction > 0 ? 1.5 : -1.5,
        scale: 0.97,
        filter: desktopBlur(isMobile, 6),
      }),
    },
    transition: { duration: 0.95, ease: [0.45, 0, 0.2, 1] },
  };
};
